(($, Drupal, once) => {
  Drupal.behaviors.photoGalleryCarousel = {
    attach: (context) => {
      once('photoGalleryCarousel', '.js-photo-gallery', context).forEach(
        (element) => {
          const $element = $(element);

          // Remodal Init
          const $modal = $(`.js-gallery-modal-${$element.data('id')}`);
          let $splide;
          let currentSlide = 0;

          // Remodal Options: https://github.com/VodkaBears/Remodal#options
          const remodalOptions = {
            hashTracking: false,
            modifier: 'photo-gallery-carousel',
          };

          $modal.remodal(remodalOptions);

          // Splide Init - while modal is opening
          $(document).on('opening', $modal, function initSplide() {
            const $splideWrapper = $modal.find('.splide');

            if ($splideWrapper.length) {
              // Splide Options: https://splidejs.com/guides/options/
              const splideOptions = {
                start: currentSlide,
                type: 'loop',
                gap: 24,
                perPage: 1,
                perMove: 1,
                pagination: false,
              };

              // eslint-disable-next-line no-undef
              $splide = new Splide($splideWrapper[0], splideOptions);
              $splide.mount();
            }
          });

          // Splide Refresh - after splide to determines the modal width
          $(document).on('opened', $modal, function initSplide() {
            $splide.refresh();
          });

          // Splide Destroy - once modal closes
          $(document).on('closed', $modal, function destroySplide() {
            $splide.destroy();
          });

          // Modal Triggers
          const $modalTriggers = $element.find('.js-modal-trigger');

          $modalTriggers.on('click', function updateCurrentSlide() {
            currentSlide = $(this).data('slide');
          });

          $modalTriggers.on('keydown', function updateCurrentSlide(e) {
            if (e.key === 'Enter') {
              $(this).click();
            }
          });
        },
      );
    },
  };
})(jQuery, Drupal, once);
